import { useUserStore } from "@/stores/user";
import { createRouter, createWebHistory, RouteRecordRaw } from "vue-router";

export {}

import 'vue-router'

declare module 'vue-router' {

    interface RouteMeta {
        title?: string;
        requiresAuth?: boolean;
        disabledAfterLogin?: boolean;
        hideOnNav?: boolean;
        requiresAdmin?: boolean;
    }
}

export const routes: Array<RouteRecordRaw> = [
    {
        path: "/",
        name: "home",
        component: () => import("@v/HomeView.vue"),
        meta: {
            title: "Home",
            requiresAuth: false,
        },
    },
    {
        path: "/login",
        name: "login",
        component: () => import("@v/LoginView.vue"),
        meta: {
            title: "Sign in",
            requiresAuth: false,
            disabledAfterLogin: true,
        },
    },
    {
        path: "/requests",
        name: "requests",
        component: () => import("@/views/RequestView.vue"),
        meta: {
            title: "Requests",
        },
    },
    {
        path: "/signup",
        name: "signup",
        component: () => import("@v/SignupView.vue"),
        meta: {
            title: "Create account",
            requiresAuth: false,
            disabledAfterLogin: true,
        },
    },
    {
        path: "/signup/result",
        name: "result",
        component: () => import("@v/SignupResultView.vue"),
        meta: {
            title: "Account created",
            requiresAuth: false,
            disabledAfterLogin: true,
            hideOnNav: true,
        },
    },
    {
        path: "/accounts",
        name: "accounts",
        component: () => import("@v/AccountView.vue"),
        props: { tab: "accounts" },
        meta: {
            title: "Account",
        },
    },
    {
        path: "/accounts/billing",
        name: "billing",
        component: () => import("@v/AccountView.vue"),
        props: { tab: "billing" },
        meta: {
            title: "Billing",
            hideOnNav: true,
        },
    },
    {
        path: "/mapping",
        name: "mapping",
        component: () => import("@v/MappingView.vue"),
        meta: {
            title: "Mapping",
            hideOnNav: true,
        },
    },
    {
        path: "/onboarding",
        name: "onboarding",
        component: () => import("@v/OnboardingView.vue"),
        meta: {
            title: "Setup",
            hideOnNav: true,
            requiresAuth: true,
        },
    },
    {
        path: "/admin",
        name: "admin",
        component: () => import("@v/AdminView.vue"),
        props: { tab: "accounts" },
        meta: {
            title: "Admin",
            requiresAdmin: true,
        },
    },
    {
        path: "/admin/plans",
        name: "admin-plans",
        component: () => import("@v/AdminView.vue"),
        props: { tab: "plans" },
        meta: {
            title: "Plans",
            requiresAdmin: true,
            hideOnNav: true,
        },
    },
    {
        path: "/invites",
        name: "invites",
        component: () => import("@v/InviteView.vue"),
        meta: {
            title: "Invites",
        },
    },
];

const router = createRouter({
    history: createWebHistory(import.meta.env.BASE_URL),
    routes
});

router.beforeEach(async (to, from, next) => {
    const { user } = useUserStore();

    if (!user && (to.meta.requiresAuth ?? true)) next({ name: "login" });
    else if (to.meta.requiresAdmin && !user?.isAdmin) next({ name: "home" });
    else next();

    document.title = to.meta.title ? `${to.meta.title} - Sorex` : "Sorex";
});

export default router;
